var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1847_21808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7109 5.07031H32.5684V3.92773C32.5684 2.03768 31.0307 0.5 29.1406 0.5H6.28906C4.39901 0.5 2.86133 2.03768 2.86133 3.92773V31.502C2.86133 33.392 4.39901 34.9297 6.28906 34.9297H7.43164V36.0723C7.43164 37.9623 8.96932 39.5 10.8594 39.5H33.7109C35.601 39.5 37.1387 37.9623 37.1387 36.0723V8.49805C37.1387 6.60799 35.601 5.07031 33.7109 5.07031ZM8.43559 9.306C7.78813 9.95339 7.43164 10.8141 7.43164 11.7297V32.6445H6.28906C5.65904 32.6445 5.14648 32.132 5.14648 31.502V3.92773C5.14648 3.29772 5.65904 2.78516 6.28906 2.78516H29.1406C29.7706 2.78516 30.2832 3.29772 30.2832 3.92773V5.07031H14.091C13.1755 5.07031 12.3147 5.42687 11.6673 6.07426L8.43559 9.306ZM14.2871 7.35547V11.9258H9.7168V11.7297C9.7168 11.4246 9.83562 11.1376 10.0514 10.9218L13.2832 7.69009C13.499 7.4743 13.7859 7.35547 14.091 7.35547H14.2871ZM34.8535 36.0723C34.8535 36.7023 34.341 37.2148 33.7109 37.2148H10.8594C10.2294 37.2148 9.7168 36.7023 9.7168 36.0723V14.2109H15.4297C16.0607 14.2109 16.5723 13.6994 16.5723 13.0684V7.35547H33.7109C34.341 7.35547 34.8535 7.86803 34.8535 8.49805V36.0723Z",
    fill: "#3E3E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4258 16.6484H13.1445C12.5135 16.6484 12.002 17.16 12.002 17.791C12.002 18.422 12.5135 18.9336 13.1445 18.9336H31.4258C32.0568 18.9336 32.5684 18.422 32.5684 17.791C32.5684 17.16 32.0568 16.6484 31.4258 16.6484Z",
    fill: "#3E3E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4258 21.2188H13.1445C12.5135 21.2188 12.002 21.7303 12.002 22.3613C12.002 22.9923 12.5135 23.5039 13.1445 23.5039H31.4258C32.0568 23.5039 32.5684 22.9923 32.5684 22.3613C32.5684 21.7303 32.0568 21.2188 31.4258 21.2188Z",
    fill: "#3E3E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4258 25.7891H13.1445C12.5135 25.7891 12.002 26.3006 12.002 26.9316C12.002 27.5626 12.5135 28.0742 13.1445 28.0742H31.4258C32.0568 28.0742 32.5684 27.5626 32.5684 26.9316C32.5684 26.3006 32.0568 25.7891 31.4258 25.7891Z",
    fill: "#3E3E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4258 30.3594H13.1445C12.5135 30.3594 12.002 30.8709 12.002 31.502C12.002 32.133 12.5135 32.6445 13.1445 32.6445H31.4258C32.0568 32.6445 32.5684 32.133 32.5684 31.502C32.5684 30.8709 32.0568 30.3594 31.4258 30.3594Z",
    fill: "#3E3E4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1847_21808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon5);
export default __webpack_public_path__ + "static/media/file-icon-5.abefd903a70aad63835b2b3bc5575b8f.svg";
export { ForwardRef as ReactComponent };